var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-page-content-template',{attrs:{"title":"サブスクリプション契約","subtitle":"Subscription"}},[(_vm.createdStep)?_c('step-contents',{attrs:{"steps":_vm.steps}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }